import { atom, PrimitiveAtom } from 'jotai'

import { currentEnv } from '@/env/vars.ts'
import { IBanner } from '@/types/app/App'
import { GET } from '@/utils/fetch'

export const getMaintenanceData = async () => {
    const res = await GET<{ data: Array<IBanner> }>(`${currentEnv.utilityUrl}/announcements`)
    if (res && res.data) {
        return res.data
    }
    return []
}

export const idTokenAtom = atom('')
export const searchAtom = atom('')
export const debugModeAtom: PrimitiveAtom<boolean> = atom(false)
